import { render, staticRenderFns } from "./orderProduct.vue?vue&type=template&id=c7dad390&"
import script from "./orderProduct.vue?vue&type=script&lang=js&"
export * from "./orderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports